<template>
  <div>
    <div class="main" v-for="(license, index) in downloadedData" :key="index">
      <div class="_paper_style">
        <h3 class="text-center">بسمه تعالی</h3>

        <div class="_certificate_info">
          <p>شماره مجوز: {{ $route.query.code }}</p>

          <p>تاریخ :{{ convertDate(license.printDate, 'fa', 'YYYY/M/D') }}</p>

          <p>Date: {{ convertDate(license.printDate, 'en', 'D/M/YYYY') }}</p>
        </div>

        <div>
          <h2 class="text-center">گواهی پایان دوره آموزش آزاد</h2>

          <div class="_main_context">
            <p>گواهی میشود</p>

            <p>
              آقای
              <span class="_bold_context">{{ license.fullName }}</span>

              دارای کد ملی {{ license.nationalCode }}
              <span class="_bold_context">{{ license.courseTitle }} </span>

              را به مدت 300 ساعت، در دانشکده مدیریت دانشگاه تهران با موفقیت به پایان رسانده است.
            </p>
          </div>

          <div class="_english_context">
            <p>This is to certify that:</p>

            <p>
              Mr. <span class="_bold_context">{{ license.englishFullName }}</span> holder of National lD {{ license.nationalCode }}, has successfully fulfilled the hybrid
              short-term program entitled <span class="_bold_context">{{ license.courseEnglishTitle }}</span> in {{ license.hour }} hours in the
              {{ license.facultyEnglishTitle }} at the University of Tehran.
            </p>
          </div>

          <div class="_signature_parent">
            <div class="_signature_box">
              {{ license.facultySignature }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'jalali-moment'

export default {
  name: 'home',
  data() {
    return {
      loading: true,
      mode: this.$route.params.type,
    }
  },
  props: {
    peopleLicense: { type: Object, required: false },
    downloadedData: { type: Array, required: false },
  },
  methods: {
    convertDate(date, local, format) {
      let finalTime = moment(date).locale(local).format(format)

      return finalTime
    },
  },
}
</script>

<style scoped>
._paper_style {
  padding: 190px 100px 25px 100px;
  page-break-after: always;
}

._certificate_info {
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: left;
}

._main_context {
  font-size: 16px;
  margin: 16px 0;
  line-height: 35px;
}

._bold_context {
  font-size: 15px;
  font-weight: bold;
}

._main_context p {
  margin-bottom: 0;
}

._english_context {
  margin: 90px 0;
  line-height: 35px;
  font-size: 16px;
  direction: ltr;
  text-align: left;
}

._english_context p {
  margin-bottom: 0;
}

._signature_parent {
  display: flex;
  align-items: center;
  margin-top: 70px;
  gap: 15px;
}

._signature_box {
  display: flex;
  flex-direction: column;
  text-align: center;
}

._signature_context {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 70px;
}

._signature_box p {
  margin-bottom: 0;
}

._horizontal_upper_page {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

._middle_of_header {
  display: flex;
  flex-direction: column;
  text-align: center;
}

._middle_of_header h3 {
  text-align: center;
  font-family: IranNastaliq !important;
}

._lower_part_of_header {
  display: flex;
  gap: 5px;
}

._lower_part_of_header h5 {
  /* font-family: IranNastaliq !important; */
}

._user_image {
  width: 90px;
  height: 125px;
  border: 1px solid gray;
  border-radius: 4px;
}

._horizontal_context {
  font-size: 16px;
  margin: 16px 0;
  line-height: 35px;
}

._horizontal_context p {
  margin-bottom: 0;
  /* font-family: IranNastaliq !important ; */
  font-size: 30px;
}

._bold_horizontal_context {
  font-size: 15px;
  font-weight: bold;
  /* font-family: IranNastaliq !important; */
  font-size: 30px;
}

._horizontal_signature {
  display: flex;
  align-items: center;
  margin-top: 20px;
  gap: 25px;
}

._horizontal_signature_box {
  display: flex;
  flex-direction: column;
  text-align: center;
}

._horizontal_signature_box p {
  margin-bottom: 0;
  /* font-family: IranNastaliq !important; */
}
</style>
